const flow = {
    steps: [
        {
            key: 'info',
            state: 'settings-profile.overview.info',
        },
        {
            key: 'email',
            state: 'settings-profile.overview.email',
        },
        {
            key: 'code',
            state: 'settings-profile.overview.code',
        },
        {
            key: 'complete',
            state: 'settings-profile.overview.complete',
            complete: true,
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/settings/controllers/profile/controllers/overview/flow.ts